import { Button } from './Button';
import s from './ConfirmInline.module.css';

interface Props {
  /** What is about to happen, and what it costs. Not "Are you sure?". */
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * A destructive confirmation that appears in place rather than in a modal.
 *
 * Deliberately not a dialog: these sit inside a list of similar rows, and a
 * modal would hide the row you were about to act on — which is the one piece of
 * context that stops you deleting the wrong one.
 */
export function ConfirmInline({
  message,
  confirmLabel,
  cancelLabel = 'Keep',
  busy = false,
  onConfirm,
  onCancel,
}: Props): JSX.Element {
  return (
    <div className={s.root} role="group" aria-label={message}>
      <span className={s.text}>{message}</span>
      <Button type="button" variant="ghost" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button type="button" variant="danger" loading={busy} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </div>
  );
}
